"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlogHeaderPublishDate = exports.BlogHeaderTitle = exports.BlogHeaderImage = void 0;

var styled_components_1 = __importStar(require("styled-components"));

exports.BlogHeaderImage = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-self: flex-start;\n  width: '100%';\n  height: '100%';\n\n  @media screen and (min-width: 840px) {\n    > * {\n      margin-right: 20px;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-self: flex-start;\n  width: '100%';\n  height: '100%';\n\n  @media screen and (min-width: 840px) {\n    > * {\n      margin-right: 20px;\n    }\n  }\n"])));
exports.BlogHeaderTitle = styled_components_1.default.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n  justify-content: center;\n  display: flex;\n  flex-direction: row;\n  margin-top: 24px;\n  margin-bottom: 8px;\n"], ["\n  text-align: center;\n  justify-content: center;\n  display: flex;\n  flex-direction: row;\n  margin-top: 24px;\n  margin-bottom: 8px;\n"])));
exports.BlogHeaderPublishDate = styled_components_1.default.div(function (_a) {
  var _b = _a.color,
      color = _b === void 0 ? '#DB704B' : _b;
  return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    justify-content: center;\n    text-align: center;\n    color: ", ";\n    letter-spacing: 0.1rem;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 32px;\n  "], ["\n    justify-content: center;\n    text-align: center;\n    color: ", ";\n    letter-spacing: 0.1rem;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 32px;\n  "])), color);
});
var templateObject_1, templateObject_2, templateObject_3;